import { Component, EventEmitter, OnInit, Output } from "@angular/core";
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";
import {
  NgxImageCompressFormat,
  NgxImageCompressService,
} from "ngx-image-compress";
import { Observable } from "rxjs";
import { map, startWith } from "rxjs/operators";
import dataURItoBlob from "src/app/utils/dataURItoBlob";
import { MyErrorStateMatcher, RequireMatch } from "src/app/utils/requireMatch";
import { MaterialsService } from "src/app/views/materials/materials/materials.service";
import { MantenimientoService } from "../mantenimiento.service";
import { ComboDisplay } from "src/app/models/dto/combo-display.dto";

@Component({
  selector: "app-modal-asignar",
  templateUrl: "./modal.component.html",
})
export class MantenimientoMaterialModal implements OnInit {
  public form: FormGroup;
  llimite: string;
  list: any[] = [];
  public listMecanicos: ComboDisplay[] = [];

  filters: Observable<any[]>[] = [];
  matcher = new MyErrorStateMatcher();
  public fileList: File[] = [];
  public imagesList: any[] = [];

  constructor(
    private fb: FormBuilder,
    private serv: MaterialsService,
    private servMant: MantenimientoService,
    public dialogRef: MatDialogRef<MantenimientoMaterialModal>,
    private imageCompress: NgxImageCompressService,
  ) {}

  get lista() {
    return this.form.get("Lista") as FormArray;
  }

  get mecanicos() {
    return this.form.get("Mecanicos") as FormArray;
  }

  public ngOnInit() {
    this.buildForm();
    this.serv.get("1").subscribe((data) => {
      this.list = data.map((m) => {
        return { Id: m.IdMaterial, Desc: m.Descripcion };
      });
    });
    this.servMant.getMecanicos().subscribe((data) => {
      this.listMecanicos = data;
    });
  }

  // TODO add validators
  private buildForm() {
    this.form = this.fb.group({
      Lista: this.fb.array([
        this.fb.group({
          Material: new FormControl("", [Validators.required, RequireMatch]),
          CantMaterial: [1],
        }),
      ]),
      Mecanicos: this.fb.array([
        this.fb.group({
          Mecanico: new FormControl("", [Validators.required]),
        }),
      ]),
    });
    this.filters.push(
      ((this.form.get("Lista") as FormArray).controls[0] as FormGroup).controls[
        "Material"
      ].valueChanges.pipe(
        startWith(""),
        map((value) => this._filter(value)),
      ),
    );
  }

  addMaterial() {
    this.lista.push(
      this.fb.group({
        Material: new FormControl("", [Validators.required, RequireMatch]),
        CantMaterial: [1],
      }),
    );
    let inx = this.lista.length - 1;
    this.filters.push(
      (
        (this.form.get("Lista") as FormArray).controls[inx] as FormGroup
      ).controls["Material"].valueChanges.pipe(
        startWith(""),
        map((value) => this._filter(value)),
      ),
    );
  }
  removeMaterial(i: number) {
    this.lista.removeAt(i);
    this.filters.splice(i, 1);
  }

  addMecanico() {
    this.mecanicos.push(
      this.fb.group({
        Mecanico: new FormControl("", [Validators.required]),
      }),
    );
  }
  removeMecanicos(i: number) {
    this.mecanicos.removeAt(i);
  }

  save() {
    const dataForm = this.form.value;
    const data = dataForm["Lista"].map((m) => {
      return { IdMaterial: m.Material.Id, CantMaterial: m.CantMaterial };
    });
    const dataMec = dataForm["Mecanicos"];
    this.dialogRef.close({
      Lista: data,
      Mecanicos: dataMec,
      Tipo: 1,
      files: this.fileList,
    });
  }

  displayWith(item?: any): string | undefined {
    return item ? item.Desc : undefined;
  }
  private _filter(value: any): string[] {
    let filterValue;
    if (typeof value === "string") filterValue = value.toLowerCase();
    else filterValue = value.Desc.toLowerCase();

    return this.list.filter((option) =>
      option.Desc.toLowerCase().includes(filterValue),
    );
  }
  public getFile() {
    this.imageCompress
      .uploadMultipleFiles()
      .then((arrayOfFiles: NgxImageCompressFormat[]) => {
        for (let index = 0; index < arrayOfFiles.length; index++) {
          const element = arrayOfFiles[index];
          this.imageCompress
            .compressFile(element.image, element.orientation, 50, 50) // 50% ratio, 50% quality
            .then((compressedImage) => {
              const blob = dataURItoBlob(compressedImage);
              this.imagesList.push(compressedImage);
              this.fileList.push(
                new File([blob], "Imagen" + new Date().getTime().toString(16)),
              );
            });
        }
      });
  }
  public removeImage(src) {
    const inx = this.imagesList.findIndex((f) => f == src);
    this.imagesList.splice(inx, 1);
    this.fileList.splice(inx, 1);
  }
}
